export const AWS = 'Amazon Web Services';
export const ECR_PUBLIC = 'ECR Public';
export const ECR_PUBLIC_GALLERY = `Amazon ${ECR_PUBLIC} Gallery`;
export const ECR_PTC = 'ECR pull through cache';
